module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_1-4742566ce95d3bdfda2c2633b43e5dca.jpg";